import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "protocol-gateway" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 1 }

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { protocolDataList, ProtocolRecord } from '@/data/protocolData'

// 定义数据类型接口
// interface ProtocolRecord { // 已在 protocolData.ts 中定义，此处可以删除
//   index: number
//   type: string
//   name: string
//   etcdKey: string
//   code: string
//   trans: string
// }

// 搜索参数

export default /*@__PURE__*/_defineComponent({
  __name: 'ProtocolGateway',
  setup(__props) {

const searchParams = ref({
  name: '',
  code: ''
})

const tabKey = ref('all')
const router = useRouter()

const columns = [
  { title: '序号', dataIndex: 'index', key: 'index' },
  { title: '协议类型', dataIndex: 'type', key: 'type' },
  { title: '协议名称', dataIndex: 'name', key: 'name' },
  { title: '协议etcdKey', dataIndex: 'etcdKey', key: 'etcdKey' },
  { title: '协议code', dataIndex: 'code', key: 'code' },
  { title: '传输协议', dataIndex: 'trans', key: 'trans' },
  { title: '操作', key: 'action' }
]

// 使用导入的数据列表
const dataSource = protocolDataList

const pagination = ref({
  total: dataSource.length,
  pageSize: 15,
  current: 1
})

// 过滤后的数据源
const filteredDataSource = computed(() => {
  return dataSource.filter(item => {
    const nameMatch = searchParams.value.name ? item.name.includes(searchParams.value.name) : true
    const codeMatch = searchParams.value.code ? item.code.includes(searchParams.value.code) : true
    return nameMatch && codeMatch
  })
})

// 搜索方法
function handleSearch() {
  pagination.value.current = 1 // 重置到第一页
}

// 重置方法
function handleReset() {
  searchParams.value.name = ''
  searchParams.value.code = ''
  pagination.value.current = 1 // 重置到第一页
}

// 添加参数类型
function goDetail(record: ProtocolRecord) {
  router.push(`/network/gateway/${record.code}`)
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "inline",
          class: "search-bar"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "协议名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: searchParams.value.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.name) = $event)),
                  placeholder: "请输入协议名称",
                  style: {"width":"180px"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "协议code" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: searchParams.value.code,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.code) = $event)),
                  placeholder: "请输入协议code",
                  style: {"width":"180px"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("查询")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { onClick: handleReset }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("重置")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_table, {
          columns: columns,
          "data-source": filteredDataSource.value,
          pagination: {
          total: filteredDataSource.value.length,
          pageSize: 15,
          current: pagination.value.current,
          showTotal: (total) => `共 ${total} 条记录`,
          onChange: (page, pageSize) => {
            pagination.value.current = page;
            pagination.value.pageSize = pageSize;
          }
        },
          style: {"margin-top":"16px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: () => goDetail(record),
                  style: {"color":"#1677ff"}
                }, "查看", 8, _hoisted_2))
              : (column.key === 'etcdKey')
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createTextVNode(_toDisplayString(record.etcdKey) + " ", 1),
                    _createVNode(_component_a_icon, {
                      type: "copy",
                      style: {"margin-left":"4px"}
                    })
                  ]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data-source", "pagination"])
      ]),
      _: 1
    })
  ]))
}
}

})